import PropTypes from 'prop-types';
import React, {Component} from 'react';

class ResizeSensor extends Component {

    static propTypes = {
        onResize: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.iframeRef = React.createRef();

    }

    render() {
        return (
            <iframe ref={this.iframeRef} style={{
                height: '100%',
                width: '100%',
                border: 'none',
                background: 'transparent',
                position: 'absolute',
                zIndex: -1,
                top: 0,
                left: 0,
            }}/>
        );
    }

    componentDidMount() {
        this.iframeRef.current.contentWindow.addEventListener('resize', this._handleResize);
    }


    componentWillUnmount() {
        this.iframeRef.current.contentWindow.removeEventListener('resize', this._handleResize);
    }


    _handleResize = () => {
        window.requestAnimationFrame(this.props.onResize);
    }

}

export default ResizeSensor


/** WEBPACK FOOTER **
 ** ./src/components/ResizeSensor.js
 **/